import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LocalizationService } from '../../core/localization/localization.service';
import { AinPageComponent } from '../../shared/design-system/page.component';

@Component({
  standalone: true,
  selector: 'ain-finance-control-center',
  imports: [AinPageComponent, RouterLink],
  template: `
    <ain-page [title]="t('finance.controlCenter.title')" [description]="t('finance.controlCenter.description')">
      <section class="section grid">
        <a class="card" [routerLink]="['/financial/control-center/capabilities']">
          <h3>{{ t('finance.controlCenter.cards.capabilities.title') }}</h3>
          <p>{{ t('finance.controlCenter.cards.capabilities.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/financial/control-center/books']">
          <h3>{{ t('finance.controlCenter.cards.books.title') }}</h3>
          <p>{{ t('finance.controlCenter.cards.books.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/financial/control-center/periods']">
          <h3>{{ t('finance.controlCenter.cards.periods.title') }}</h3>
          <p>{{ t('finance.controlCenter.cards.periods.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/financial/management/chart-of-accounts']">
          <h3>{{ t('finance.controlCenter.cards.chartOfAccounts.title') }}</h3>
          <p>{{ t('finance.controlCenter.cards.chartOfAccounts.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/financial/control-center/funds']">
          <h3>{{ t('finance.controlCenter.cards.funds.title') }}</h3>
          <p>{{ t('finance.controlCenter.cards.funds.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/financial/control-center/accounting-basis']">
          <h3>{{ t('finance.controlCenter.cards.accountingBasis.title') }}</h3>
          <p>{{ t('finance.controlCenter.cards.accountingBasis.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/financial/control-center/journal-policy']">
          <h3>{{ t('finance.controlCenter.cards.journalPolicy.title') }}</h3>
          <p>{{ t('finance.controlCenter.cards.journalPolicy.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/financial/payments/customers']">
          <h3>{{ t('finance.controlCenter.cards.customers.title') }}</h3>
          <p>{{ t('finance.controlCenter.cards.customers.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/financial/control-center/currencies']">
          <h3>{{ t('finance.controlCenter.cards.currencies.title') }}</h3>
          <p>{{ t('finance.controlCenter.cards.currencies.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/financial/control-center/fx-rates']">
          <h3>{{ t('finance.controlCenter.cards.fxRates.title') }}</h3>
          <p>{{ t('finance.controlCenter.cards.fxRates.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/financial/control-center/currency-policies']">
          <h3>{{ t('finance.controlCenter.cards.currencyPolicy.title') }}</h3>
          <p>{{ t('finance.controlCenter.cards.currencyPolicy.description') }}</p>
        </a>
      </section>

      <section class="section">
        <h3>{{ t('finance.controlCenter.workspaces.title') }}</h3>
        <div class="links">
          <a [routerLink]="['/financial/budgets']">{{ t('finance.controlCenter.workspaces.budgets') }}</a>
          <a [routerLink]="['/financial/reconciliation']">{{ t('finance.controlCenter.workspaces.reconciliation') }}</a>
          <a [routerLink]="['/financial/consolidation']">{{ t('finance.controlCenter.workspaces.consolidation') }}</a>
          <a [routerLink]="['/financial/semantic-metrics']">{{ t('finance.controlCenter.workspaces.semanticMetrics') }}</a>
          <a [routerLink]="['/financial/ai-recommendations']">{{ t('finance.controlCenter.workspaces.aiRecommendations') }}</a>
          <a [routerLink]="['/financial/control-center/currencies']">{{ t('finance.controlCenter.workspaces.currencyMaster') }}</a>
          <a [routerLink]="['/financial/control-center/fx-rates']">{{ t('finance.controlCenter.workspaces.fxRates') }}</a>
          <a [routerLink]="['/financial/control-center/currency-policies']">{{ t('finance.controlCenter.workspaces.currencyPolicy') }}</a>
          <a [routerLink]="['/financial/control-center/journal-policy']">{{ t('finance.controlCenter.workspaces.journalPolicy') }}</a>
          <a [routerLink]="['/financial/payments/customers']">{{ t('finance.controlCenter.workspaces.customers') }}</a>
        </div>
      </section>
    </ain-page>
  `,
  styles: [`
    .section { margin-bottom: 24px; display: grid; gap: 12px; }
    .grid { grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); }
    .card { border: 1px solid #e5e7eb; border-radius: 12px; padding: 12px; }
    .card:hover { border-color: var(--ain-color-primary); }
    .links { display: flex; flex-wrap: wrap; gap: 10px; }
    a { color: var(--ain-color-primary); font-weight: 600; text-decoration: none; }
    p { margin: 0; color: #475569; font-weight: 400; }
  `]
})
export class FinanceControlCenterComponent {
  private readonly localization = inject(LocalizationService);

  t(key: string): string {
    return this.localization.translate(key);
  }
}
